export default "__VITE_ASSET__D5BYW96F__"